import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/About.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const About: React.FC = () => {
  const [settings, setSettings] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/admin/settings`).catch(() => ({ data: [] }));
        const settingsMap: Record<string, string> = {};
        if (res.data && Array.isArray(res.data)) {
           res.data.forEach((s: any) => {
             settingsMap[s.key] = s.value;
           });
        }
        setSettings(settingsMap);
      } catch (error) {
        console.error('Error fetching about settings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const content = {
    bannerTitle: settings['about_banner_title'] || 'Sobre a Clínica CIS',
    bannerSubtitle: settings['about_banner_subtitle'] || 'Nossa história, missão e compromisso com a sua saúde e bem-estar.',
    historyTitle: settings['about_history_title'] || 'Nossa História',
    history: settings['about_history'] || 'A Clínica CIS nasceu de um sonho de oferecer um espaço completo e acolhedor para o cuidado integral da saúde e bem-estar em Ji-Paraná, Rondônia.',
    history2: settings['about_history2'] || 'Desde o início, investimos em tecnologia de ponta, em um ambiente moderno e, acima de tudo, em uma equipe multidisciplinar altamente qualificada e dedicada.',
    mission: settings['about_mission'] || 'Nossa missão é promover a saúde, a recuperação e a qualidade de vida de nossos pacientes, oferecendo serviços de alta qualidade, atendimento humanizado e soluções personalizadas.',
    vision: settings['about_vision'] || 'Ser a clínica de referência em fisioterapia, pilates, estética e massoterapia na região, reconhecida pela excelência de seus serviços, pela inovação e pelo impacto positivo na vida das pessoas.'
  };

  return (
    <div className="about-page">
      <section className="hero-about">
        <div className="container">
          <h1>{content.bannerTitle}</h1>
          <p>{content.bannerSubtitle}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>{content.historyTitle}</h2>
              <p>{content.history}</p>
              <p>{content.history2}</p>
            </div>
            <div className="about-image">
              <img src="/logo.png" alt="Nossa História - Logo CIS" style={{ maxWidth: '300px', border: 'none', boxShadow: 'none' }} />
            </div>
          </div>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <div className="about-content reverse">
            <div className="about-text">
              <h2>Nossa Missão</h2>
              <p>{content.mission}</p>
              <h2>Nossa Visão</h2>
              <p>{content.vision}</p>
              <h2>Nossos Valores</h2>
              <ul>
                <li><strong>Excelência:</strong> Busca contínua pela qualidade em todos os serviços.</li>
                <li><strong>Humanização:</strong> Atendimento com empatia, respeito e carinho.</li>
                <li><strong>Inovação:</strong> Acompanhamento das últimas tendências e tecnologias.</li>
                <li><strong>Integridade:</strong> Ética e transparência em todas as relações.</li>
                <li><strong>Comprometimento:</strong> Dedicação total aos resultados e satisfação do paciente.</li>
              </ul>
            </div>
            <div className="about-image">
              <img src="https://via.placeholder.com/600x400?text=Bem-Estar+e+Sa%C3%BAde" alt="Nossa Missão" />
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container text-center">
          <h2>Nossa Equipe</h2>
          <p className="section-subtitle">
            Conheça os profissionais dedicados que fazem da Clínica CIS um lugar de cuidado e excelência.
          </p>
          <div className="team-grid">
            <div className="team-member">
              <img src="https://via.placeholder.com/200x200?text=Profissional+1" alt="Profissional 1" />
              <h3>Dra. Ana Paula</h3>
              <p>Fisioterapeuta e Especialista em Pilates</p>
              <div className="social-icons">
                <a href="#"><i className="fab fa-instagram"></i></a>
                <a href="#"><i className="fab fa-linkedin"></i></a>
              </div>
            </div>
            <div className="team-member">
              <img src="https://via.placeholder.com/200x200?text=Profissional+2" alt="Profissional 2" />
              <h3>Dr. João Silva</h3>
              <p>Quiropraxista e Acupunturista</p>
              <div className="social-icons">
                <a href="#"><i className="fab fa-instagram"></i></a>
                <a href="#"><i className="fab fa-linkedin"></i></a>
              </div>
            </div>
            <div className="team-member">
              <img src="https://via.placeholder.com/200x200?text=Profissional+3" alt="Profissional 3" />
              <h3>Dra. Carla Mendes</h3>
              <p>Esteticista e Massoterapeuta</p>
              <div className="social-icons">
                <a href="#"><i className="fab fa-instagram"></i></a>
                <a href="#"><i className="fab fa-linkedin"></i></a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
